<div class="modal-container" #modalContainer>
  <div class="modal-header header bg-primary">
    <h2 class="modal-title text-white">
      {{ title }}
    </h2>
    @if (!hideTopClose) {
      <button type="button" class="close text-white" aria-label="Close" (click)="no()" #closeButton>
        <span aria-hidden="true">&times;</span>
      </button>
    }
  </div>

  <div class="modal-body" #modalContent>
    @if (isHtmlContent) {
      <div [innerHTML]="content"></div>
    }

    @if (!isHtmlContent) {
      <div class="container-fluid">
        <ng-container *ngTemplateOutlet="content; context: content.data"></ng-container>
      </div>
    }
  </div>

  @if (showButtons) {
    <div class="modal-footer">
      @if (!hideCancel) {
        <button type="button" class="btn btn-secondary" (click)="no()" #cancelButton>
          {{ cancelLabel }}
        </button>
      }
      @if (!hideSubmit) {
        <button type="button" class="btn btn-primary" (click)="yes()" #submitButton>
          {{ okLabel }}
        </button>
      }
    </div>
  }
</div>
